// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f14f435b","885":"5c478762"}[chunkId] + ".chunk.js";
};